import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedLopOvertimeRequestData: {},
  isModal: { model: false, submit: false },
  modalHeader: { title: '', isEdit: false, editId: '' },
  isApprovedModel: { model: false, lopOvertimeId: '' },
  isRejectedModel: { model: false, lopOvertimeId: '' },
  editLopOvertimeData: {},
  search: '',
  isDelete: { id: '', status: '' },
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  sortField: 'createdAt',
  sortDirection: false,
  loading: false,
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 10
};

// Config slice
export const lopOvertimeRequestSlice = createSlice({
  name: 'lopOvertimeRequestSlice',
  initialState,
  reducers: {
    selectedLopOvertimeRequest: (state, action) => {
      state.selectedLopOvertimeRequestData = action?.payload;
    },
    setState: (state, action) => {
      // Update the state with the new values from action.payload
      return { ...state, ...action.payload };
    }
  }
});

// Export actions
export const { selectedLopOvertimeRequest, setState } = lopOvertimeRequestSlice.actions;
// Export reducer
export const { reducer: lopOvertimeRequestReducer } = lopOvertimeRequestSlice;
